import { lazy, type ComponentType } from 'react'
import { DashSwitch } from '@retailer-platform/dashboard/routing'
import { DomainRoute } from '../utils/domain/routingComponents'
import { dietaryDiscoveryPagesAccessControl } from '../access-control/storefrontAccess.configuration'

const MarketplaceDietaryDiscoveryPageBuilderPage = lazy(
  () =>
    import(
      /* webpackChunkName: "MarketplaceDietaryDiscoveryPageBuilderPage" */
      '../pages/dietary-discovery/admin/MarketplaceDietaryDiscoveryPageBuilderPage'
    )
)

const MarketplaceDietaryDiscoveryPagesDashboardPage = lazy(
  () =>
    import(
      /* webpackChunkName: "MarketplaceDietaryDiscoveryPagesDashboardPage" */
      '../pages/dietary-discovery/admin/MarketplaceDietaryDiscoveryPagesDashboardPage'
    )
)

// Retailer/partner-agnostic Instacart-admin routes for dietary discovery pages
// (page_type: "discovery_page"). Entry point is the "Dietary Discovery Pages" item
// on the Marketplace admin nav — that lands on the dashboard, which lists one page
// per dietary preference slug. Gated by `dietaryDiscoveryPagesAccessControl`
// (the `rt_dietary_discovery_pages_mp` toggle).
export const storefrontAdminDietaryDiscoveryPagesRouter = (
  <DomainRoute
    route="storefront-admin-dietary-discovery-pages"
    accessControl={dietaryDiscoveryPagesAccessControl}
  >
    <DashSwitch>
      <DomainRoute
        exact
        route="storefront-admin-dietary-discovery-pages-edit"
        component={MarketplaceDietaryDiscoveryPageBuilderPage as ComponentType<any>}
        accessControl={dietaryDiscoveryPagesAccessControl}
      />
      <DomainRoute
        exact
        route="storefront-admin-dietary-discovery-pages"
        component={MarketplaceDietaryDiscoveryPagesDashboardPage}
        accessControl={dietaryDiscoveryPagesAccessControl}
      />
    </DashSwitch>
  </DomainRoute>
)
